import { createFeature, createReducer, on } from '@ngrx/store';
import { LeadBankActions } from './lead-bank.actions';

export interface LeadBankState {
  leadBanks: any[];
  leadBanksLoading: boolean;
  validationLoading: boolean;
  validationResult: {
    sts: string;
    correctedEmail?: string;
    existingEmailMatches?: string[];
    message?: string;
  } | null;
  submitLoading: boolean;
  error: unknown;
}

export const initialLeadBankState: LeadBankState = {
  leadBanks: [],
  leadBanksLoading: false,
  validationLoading: false,
  validationResult: null,
  submitLoading: false,
  error: null,
};

export const leadBankReducer = createReducer(
  initialLeadBankState,
  on(LeadBankActions.loadLeadBanks, state => {
    const nextError: LeadBankState['error'] = null;
    return {
      ...state,
      leadBanksLoading: true,
      error: nextError,
    };
  }),
  on(LeadBankActions.loadLeadBanksSuccess, (state, { leadBanks }) => {
    const nextError: LeadBankState['error'] = null;
    return {
      ...state,
      leadBanks,
      leadBanksLoading: false,
      error: nextError,
    };
  }),
  on(LeadBankActions.loadLeadBanksFailure, (state, { error }) => ({
    ...state,
    leadBanksLoading: false,
    error,
  })),
  on(LeadBankActions.validateEmail, state => {
    const nextError: unknown = null;
    return {
      ...state,
      validationLoading: true,
      error: nextError,
    };
  }),
  on(LeadBankActions.validateEmailSuccess, (state, { result }) => {
    const nextResult: {
      sts: string;
      correctedEmail?: string | undefined;
      existingEmailMatches?: string[] | undefined;
      message?: string;
    } | null = result;
    const nextError: unknown = null;
    return {
      ...state,
      validationLoading: false,
      validationResult: nextResult,
      error: nextError,
    };
  }),
  on(LeadBankActions.validateEmailFailure, (state, { error }) => ({
    ...state,
    validationLoading: false,
    error,
  })),
  on(LeadBankActions.clearValidation, state => {
    const nextResult: LeadBankState['validationResult'] = null;
    const nextError: unknown = null;
    return {
      ...state,
      validationResult: nextResult,
      validationLoading: false,
      error: nextError,
    };
  }),
  on(LeadBankActions.submitExternalInvest, state => {
    const nextError: unknown = null;
    return {
      ...state,
      submitLoading: true,
      error: nextError,
    };
  }),
  on(LeadBankActions.submitExternalInvestSuccess, state => {
    const nextError: unknown = null;
    return {
      ...state,
      submitLoading: false,
      error: nextError,
    };
  }),
  on(LeadBankActions.submitExternalInvestFailure, (state, { error }) => ({
    ...state,
    submitLoading: false,
    error,
  }))
);

export const LeadBankFeature = createFeature({
  name: 'leadBank',
  reducer: leadBankReducer,
});

export const {
  selectLeadBankState,
  selectLeadBanks,
  selectLeadBanksLoading,
  selectValidationLoading,
  selectValidationResult,
  selectSubmitLoading,
  selectError: selectLeadBankError,
} = LeadBankFeature;
